import React, { useState, useEffect } from 'react';
import { Button, Row, Container } from 'react-bootstrap';
import './Training.css';
import API from '../api';
import TrainingFilters from './training/TrainingFilters';
import ChallengeCard from './training/ChallengeCard';
import ChallengeDetailModal from './training/ChallengeDetailModal';
import CreateChallengeModal from './training/CreateChallengeModal';

function Training() {
    const [challenges, setChallenges] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedChallenge, setSelectedChallenge] = useState(null);
    const [newChallenge, setNewChallenge] = useState({
        title: '', category: 'OSINT', description: '', file_link: '',
        flags: [{ name: 'Flag', value: '' }], difficulty: 'Medium'
    });
    const [submissionStatus, setSubmissionStatus] = useState({});
    const [flagInputs, setFlagInputs] = useState({});
    const [createError, setCreateError] = useState(null);
    const [filters, setFilters] = useState({ search: '', category: 'All', difficulty: 'All' });

    useEffect(() => { fetchChallenges(); }, []);

    const fetchChallenges = () => {
        fetch(API.TRAINING, { method: 'GET', credentials: 'include' })
        .then(response => response.json())
        .then(data => { if (data.status === 'success') setChallenges(data.challenges); })
        .catch(error => console.error('Error fetching challenges:', error));
    };

    const getFilteredChallenges = () => {
        return challenges.filter(challenge => {
            const matchesSearch = challenge.title.toLowerCase().includes(filters.search.toLowerCase()) ||
                                challenge.description.toLowerCase().includes(filters.search.toLowerCase());
            const matchesCategory = filters.category === 'All' || challenge.category === filters.category;
            const matchesDifficulty = filters.difficulty === 'All' || challenge.difficulty === filters.difficulty;
            return matchesSearch && matchesCategory && matchesDifficulty;
        });
    };

    const handleCreateChallenge = () => {
        if (!newChallenge.title || !newChallenge.category || !newChallenge.description || !newChallenge.difficulty) {
            setCreateError('Please fill in all required fields'); return;
        }
        for (const flag of newChallenge.flags) {
            if (!flag.name || !flag.value) { setCreateError('All flags must have both a name and value'); return; }
        }
        setCreateError(null);

        fetch(API.TRAINING_CREATE, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
            body: JSON.stringify({ action: 'create_challenge', ...newChallenge }),
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === 'success') {
                fetchChallenges();
                setShowModal(false);
                setNewChallenge({ title: '', category: 'OSINT', description: '', file_link: '', flags: [{ name: 'Flag', value: '' }], difficulty: 'Medium' });
            } else { setCreateError(data.message); }
        })
        .catch(() => setCreateError('Failed to create challenge. Please try again.'));
    };

    const handleDeleteChallenge = (challengeId) => {
        if (!window.confirm('Are you sure you want to delete this challenge?')) return;
        fetch(API.TRAINING_DELETE(challengeId), { method: 'DELETE', credentials: 'include' })
        .then(response => response.json())
        .then(data => { if (data.status === 'success') { fetchChallenges(); setSelectedChallenge(null); } else { alert(data.message); } })
        .catch(() => alert('Failed to delete challenge. Please try again.'));
    };

    const handleSubmitFlag = (challengeId, flagName, flagValue) => {
        if (!flagValue) { setSubmissionStatus(prev => ({ ...prev, [flagName]: 'Please enter a flag' })); return; }
        fetch(API.TRAINING_SUBMIT, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
            body: JSON.stringify({ action: 'submit_flag', challenge_id: challengeId, submitted_flag: flagValue, flag_name: flagName }),
        })
        .then(response => response.json())
        .then(data => {
            setSubmissionStatus(prev => ({ ...prev, [flagName]: data.message }));
            if (data.status === 'success') { fetchChallenges(); setFlagInputs(prev => ({ ...prev, [flagName]: '' })); }
        })
        .catch(() => setSubmissionStatus(prev => ({ ...prev, [flagName]: 'Error submitting flag. Please try again.' })));
    };

    return (
        <Container fluid className="training-page-wrapper">
            <div className="training-main-wrapper">
                <div className="training-header-wrapper">
                    <h2>Training Exercises</h2>
                    <Button variant="primary" onClick={() => setShowModal(true)} className="training-create-button">Create Challenge</Button>
                </div>

                <TrainingFilters filters={filters} setFilters={setFilters} />

                <div className="training-grid-wrapper">
                    <Row>
                        {getFilteredChallenges().map(challenge => (
                            <ChallengeCard
                                key={challenge.id}
                                challenge={challenge}
                                onSelect={(c) => { setSelectedChallenge(c); setSubmissionStatus({}); setFlagInputs({}); }}
                                onDelete={handleDeleteChallenge}
                            />
                        ))}
                    </Row>
                </div>

                <ChallengeDetailModal
                    challenge={selectedChallenge}
                    onHide={() => { setSelectedChallenge(null); setSubmissionStatus({}); setFlagInputs({}); }}
                    flagInputs={flagInputs}
                    setFlagInputs={setFlagInputs}
                    submissionStatus={submissionStatus}
                    onSubmitFlag={handleSubmitFlag}
                />

                <CreateChallengeModal
                    show={showModal}
                    onHide={() => { setShowModal(false); setCreateError(null); }}
                    newChallenge={newChallenge}
                    setNewChallenge={setNewChallenge}
                    createError={createError}
                    onCreate={handleCreateChallenge}
                />
            </div>
        </Container>
    );
}

export default Training;
